import React from 'react';

import Section from './Section.jsx';
import Intro from './Intro.jsx';

export default class SectionIntro extends React.Component {
  render() {
    const sectionBg = require('images/header-bg.jpg');

    return (
      <Section id={'intro'} textAlign={'center'} sectionBg={sectionBg}>
        <Intro />
      </Section>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./web/js/components/SectionIntro.jsx
 **/